<div class="lv-donut-chart">

  <mat-expansion-panel class="lv-material-expansion-panel">
    <mat-expansion-panel-header class="lv-material-expansion-panel-header">
      <mat-panel-description class="right-aligned">
        Details
      </mat-panel-description>
    </mat-expansion-panel-header>

    <h2 class="lv-text-center">Aufteilung der Positionen</h2>
    <div class="lv-donut lv-flex-wrap">
      <div><canvas #canvas [width]="100" [height]="100"></canvas></div>
      <div class="lv-chart-list">
        <ng-container *ngIf="allFonds$ | async">
        <mat-list>
          <mat-list-item class="lv-chart-list-item" *ngFor="let fraction of sortedDonatDataList(), let i = index">
            <div class="lv-flex-center">
              <span class="lv-colored-dot" [style.background-color]="colors[i%colors.length]"></span>
              <div class="lv-small-text-left"> {{fraction.name}} </div>
            </div>
            <div class="lv-small-text-space-left">{{fraction.prozentualerAnteil}}%</div>
          </mat-list-item>
        </mat-list>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="!!this.url">
      <div class="lv-donat-chart-link">
        <a href="{{ url }}" target="_blank">Mehr Informationen</a>
        <mat-icon class="lv-icon-external-link" svgIcon="external-link"></mat-icon>
      </div>
    </ng-container>
  </mat-expansion-panel>

</div>
